module.exports = __webpack_public_path__ + "static/media/boomwriter-full.cbc90b8b.svg";